export default __webpack_public_path__ + "static/media/Adopt_App_Oct_2019.80b356e8.pdf";